import EmailNotificationContainer from "./EmailNotificationContainer";
import Store from "./EmailNotificationStore";

export default Store(EmailNotificationContainer);
